import { initSite, initReveal } from "./site.js";
import { injectIcons } from "./icons.js";
import { getBranchList, addBranch, removeBranch, isAdminAuthed } from "./cms/store.js";
import { applyBranchFields } from "./cms/apply.js";
import { resolveBranchImageSrc } from "./cms/branch-images.js";
import { refreshInlineCms, showCmsToast } from "./cms/inline.js";

await initSite();
renderBranchesPage();

function renderBranchesPage() {
  renderBranches();
  initBranchCards();
  initBranchAdminButtons();
  applyBranchFields();
  initReveal();
  refreshInlineCms();
}

function renderBranches() {
  const root = document.getElementById("branches-root");
  const actions = document.getElementById("branches-cms-actions");
  if (!root) return;

  root.innerHTML = getBranchList().map((branch) => renderBranchCard(branch)).join("");
  injectIcons();

  if (actions) {
    actions.innerHTML = isAdminAuthed()
      ? `<button type="button" class="bm-cms-branch-add" data-cms-branch-add>+ הוסף סניף</button>`
      : "";
  }
}

function renderBranchCard(branch) {
  const name = branch.branch || branch.title || "סניף";
  const image = resolveBranchImageSrc(branch.id, branch.image);
  const removeBtn = isAdminAuthed()
    ? `<button type="button" class="bm-cms-item-remove" data-cms-branch-remove="${branch.id}" aria-label="הסר את ${name}">×</button>`
    : "";

  return `
    <article class="product reveal bm-branch-card" data-branch="${branch.id}" tabindex="0" role="button" aria-label="${name}, לחצו לפרטים">
      ${removeBtn}
      <div class="img-container">
        <img src="${image}" alt="סניף ${name}" class="product-img" data-cms-branch-prop="image">
        <span class="bag-btn">
          <span class="bm-icon bm-icon--xs" data-icon="arrowRight" aria-hidden="true"></span>
          <span data-cms-key="branches.card.cta">לפרטי הסניף</span>
        </span>
      </div>
      <h2 data-cms-branch-prop="branch">${name}</h2>
    </article>
  `;
}

function initBranchCards() {
  const branches = Object.fromEntries(getBranchList().map((branch) => [branch.id, branch]));

  document.querySelectorAll("[data-branch]").forEach((card) => {
    const id = card.dataset.branch;
    const data = branches[id];
    if (!data) return;

    const go = () => goToBranch(id, data);

    card.addEventListener("click", go);
    card.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        go();
      }
    });

    const btn = card.querySelector(".bag-btn");
    btn?.addEventListener("click", (event) => {
      event.stopPropagation();
      go();
    });
  });
}

function initBranchAdminButtons() {
  if (!isAdminAuthed()) return;

  document.querySelectorAll("[data-cms-branch-remove]").forEach((btn) => {
    if (btn.dataset.cmsRemoveReady === "1") return;
    btn.dataset.cmsRemoveReady = "1";

    btn.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const branchId = btn.dataset.cmsBranchRemove;
      const name =
        btn.closest("[data-branch]")?.querySelector("[data-cms-branch-prop='branch']")
          ?.textContent || "הסניף";

      if (!branchId || !confirm(`להסיר את ${name}?`)) return;
      if (!removeBranch(branchId)) {
        showCmsToast("חייב להישאר לפחות סניף אחד", "error");
        return;
      }

      renderBranchesPage();
      showCmsToast("הסניף הוסר");
    });
  });

  document.querySelectorAll("[data-cms-branch-add]").forEach((btn) => {
    if (btn.dataset.cmsAddReady === "1") return;
    btn.dataset.cmsAddReady = "1";

    btn.addEventListener("click", (event) => {
      event.preventDefault();
      const branchId = addBranch();
      if (!branchId) return;

      renderBranchesPage();
      showCmsToast("נוסף סניף חדש");
      requestAnimationFrame(() => {
        document
          .querySelector(`[data-branch="${branchId}"]`)
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });
  });
}

function goToBranch(id, data) {
  localStorage.setItem("myitem", JSON.stringify({ ...data, id }));
  window.location.href = "branch.html";
}
